import React, { useState, useEffect, useRef } from 'react';

import * as Yup from 'yup';
import { Formik, FieldArray, Form, Field } from 'formik';
import { toast } from 'react-toastify';

import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CircularProgress from '@material-ui/core/CircularProgress';

import { i18n } from '../../translate/i18n';

import api from '../../services/api';
import toastError from '../../errors/toastError';
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
} from '@mui/material';
import { AddCircle, Delete } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  btnWrapper: {
    position: 'relative',
  },

  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const selectFieldStyles = {
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#909090',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#000000',
    borderWidth: 'thin',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#9a00ed',
    borderWidth: 'thin',
  },
};

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Muito curto!')
    .max(50, 'Muito longo!')
    .required('Digite um nome!'),
  text: Yup.string()
    .min(2, 'Muito curto!')
    .max(50, 'Muito longo!')
    .required('Digite uma mensagem!'),
});

const FlowBuilderMenuModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [rule, setRule] = useState();

  const [textDig, setTextDig] = useState();

  const [arrayOption, setArrayOption] = useState([]);

  const [valueRadioButton, setValueRadionButton] = useState('number');

  const [labels, setLabels] = useState({
    title: 'Adicionar menu ao fluxo',
    btn: 'Adicionar',
  });

  useEffect(() => {
    console.log(data);
    if (open === 'edit') {
      setLabels({
        title: 'Editar menu',
        btn: 'Salvar',
      });
      setTextDig(data.data.message);
      setArrayOption(data.data.arrayOption);
      setValueRadionButton(data.data.typeMenu);

      setActiveModal(true);
    } else if (open === 'create') {
      setLabels({
        title: 'Adicionar menu ao fluxo',
        btn: 'Adicionar',
      });
      setTextDig();
      setArrayOption([]);
      setValueRadionButton();
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (open === 'edit') {
      handleClose();
      onUpdate({
        ...data,
        data: {
          message: textDig,
          arrayOption: arrayOption,
          typeMenu: valueRadioButton,
        },
      });
      return;
    } else if (open === 'create') {
      handleClose();
      onSave({
        message: textDig,
        arrayOption: arrayOption,
        typeMenu: valueRadioButton,
      });
    }
  };

  const removeOption = (number) => {
    setArrayOption((old) => old.filter((item) => item.number !== number));
  };

  const handleChangeRadionButton = (event) => {
    setValueRadionButton(event?.target?.value);
    console.log(event?.target?.value);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth='md'
        scroll='paper'
      >
        <DialogTitle id='form-dialog-title'>{labels.title}</DialogTitle>
        <Stack>
          <Stack dividers style={{ gap: '8px', padding: '16px' }}>
            <Stack sx={{ padding: '20px 20px', display: 'flex' }}>
              <RadioGroup
                defaultValue='numero'
                value={valueRadioButton}
                onChange={handleChangeRadionButton}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
                row
              >
                <FormControlLabel
                  value='number'
                  control={<Radio />}
                  label='Número'
                />
                <FormControlLabel
                  value='list'
                  control={<Radio />}
                  label='Lista'
                />
                <FormControlLabel
                  value='button'
                  control={<Radio />}
                  label='Botão'
                />
              </RadioGroup>
            </Stack>
            <TextField
              label={'Mensagem de explicação do menu'}
              rows={4}
              name='text'
              multiline
              variant='outlined'
              value={textDig}
              onChange={(e) => setTextDig(e.target.value)}
              className={classes.textField}
              style={{ width: '100%' }}
            />
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography>Adicionar Opção</Typography>
              <Button
                onClick={() =>
                  setArrayOption((old) => [
                    ...old,
                    {
                      number: old.length + 1,
                      value: '',
                      type: valueRadioButton, // NOVO ATRIBUTO
                    },
                  ])
                }
                color='primary'
                variant='contained'
              >
                <AddCircle />
              </Button>
            </Stack>
            {arrayOption.map((item, index) => (
              <Stack width={'100%'} key={item.number}>
                <Typography>Digite {item.number}</Typography>
                <Stack direction={'row'} width={'100%'} style={{ gap: '8px' }}>
                  <TextField
                    placeholder={'Digite opção'}
                    variant='outlined'
                    defaultValue={item.value}
                    style={{ width: '100%' }}
                    onChange={(event) => {
                      const value = event.target.value;

                      setArrayOption((old) =>
                        old.map((option, i) =>
                          i === index
                            ? {
                                ...option,
                                value,
                              }
                            : option,
                        ),
                      );
                    }}
                  />
                  {arrayOption.length === item.number && (
                    <IconButton onClick={() => removeOption(item.number)}>
                      <Delete />
                    </IconButton>
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
          <DialogActions>
            <Button onClick={handleClose} color='secondary' variant='outlined'>
              {i18n.t('contactModal.buttons.cancel')}
            </Button>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              className={classes.btnWrapper}
              onClick={() => handleSaveContact()}
            >
              {`${labels.btn}`}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderMenuModal;
